export const getGadgetTimeOut = (state, id) => state.portal.gadgets[id].timeOut;
export const getSelectedRow = (state, id) => state.portal.gadgets[id].selectedRow;
